import { useMemo } from "react"
import { useQuery } from "urql"

import type { GetPurchaseOrderShortListQuery, Order, OrderListInput } from "@/graphql/codegen/graphql"
import { GetPurchaseOrderShortListDocument, OrderSortField, SortingOrder } from "@/graphql/codegen/graphql"

export const useGetPurchaseOrderSuggestions = ({
  query,
  excludeOrderIds = [],
}: {
  query: string
  excludeOrderIds?: number[]
}): {
  purchaseOrders: Order[]
  isFetching: boolean
} => {
  const shouldFetch = Boolean(query && query.length >= 2)

  const [{ data, fetching: isFetchingOrders }] = useQuery<GetPurchaseOrderShortListQuery, { input: OrderListInput }>({
    query: GetPurchaseOrderShortListDocument,
    pause: !shouldFetch,
    variables: {
      input: {
        filter: {
          query,
        },
        limit: 50,
        offset: 0,
        sort: {
          field: OrderSortField.UpdatedOn,
          order: SortingOrder.Desc,
        },
      },
    },
  })

  const purchaseOrders = useMemo(() => {
    if (!data || data.order.list.__typename !== "OrderListSuccess") {
      return []
    }

    return data.order.list.orders.filter((order) => !excludeOrderIds.includes(order.orderId))
  }, [data, excludeOrderIds])

  return {
    purchaseOrders,
    isFetching: isFetchingOrders,
  }
}
